/* istanbul ignore file */
import {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common/dist/types/types';

export const getOptionsButtonsCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const {productPage_buttonOptionsVerticalPadding, productPage_buttonOptionsHorizontalPadding} = styleParams.numbers;
  return {
    buttonOptionsPadding: `${productPage_buttonOptionsVerticalPadding}px ${productPage_buttonOptionsHorizontalPadding}px`,
  };
};
